import clsx from "clsx";
import React, { useEffect, useRef, useState } from 'react';
import { phuHuynhApi } from '../../api/phuHuynhApi';
import { useCommonContext } from '../../contexts/common';
import PhuHuynhEditModal from '../phu-huynh-edit-modal/PhuHuynhEditModal';
import PlaceHolder from '../place-holder/PlaceHolder';
import styles from "./PhuHuynhInfo.module.css";
const PhuHuynhInfo = ({ id, isSelected, onSelected }) => {
    const [formData, setFormData] = useState({});
    const { translate } = useCommonContext();
    const [isLoading, setIsLoading] = useState(false);
    const componentDidMount = useRef(false);
    const [isShowEditModal, setisShowEditModal] = useState();

    useEffect(() => {
        componentDidMount.current = true;
        handeReloadData();
        return () => {
            componentDidMount.current = false;
        }
    }, [id])
    const handeReloadData = async () => {
        setIsLoading(true);
        const res = await phuHuynhApi.Detail(id);
        if (componentDidMount.current) {
            setIsLoading(false)
            if (res.is_success) {
                setFormData(res.data)
            }
        }
    }
    return (
        <div className={clsx(styles.container, isSelected ? styles.isSelected : "")}
            onClick={() => { onSelected(); }}
        >
            {isLoading && <PlaceHolder />}
            {!isLoading &&
                <>
                    <div className={styles.caption}>
                        <div className={styles.name}>{formData.ho_ten}</div>
                        <span className={styles.tag} onClick={() => {
                            setisShowEditModal(true)
                        }}>
                            <i className="far fa-edit"></i>
                        </span>
                        {/* <span className={styles.tag}>{formData.quan_he}</span> */}
                    </div>
                    <p className={styles.info_container}>
                        <i className="fas fa-at"></i>
                        <b>{formData.email}</b>
                    </p>
                    <p className={styles.info_container}>
                        <i className="fas fa-phone"></i>
                        <b>{formData.dien_thoai}</b>
                    </p>
                </>}
            {isShowEditModal && <PhuHuynhEditModal
                phuHuynhId={formData.id}
                onCancel={() => { setisShowEditModal(false) }}
                onSuccess={() => { setisShowEditModal(false); handeReloadData() }}
            />}
        </div>
    );
};

export default PhuHuynhInfo;